const data = [
  {
    titulo: "Casas Filiadas",
    item: [
      "Casa de Fabiano",
      "Centro Espírita União",
      "Lar da Fernanda",
      "Lar do Heitor",
      "lar Ilza Cintra",
      "Neuchatel",
      "Lar Jésus Golçalves"
    ]
  },
  {
    titulo: "Notícias",
    item: [
      "Todas as Noticías",
      "Últimas Notícias",
      "Próximos Eventos",
      "Palestras Online"
    ]
  },
  {
    titulo: "Comunicação",
    item: ["Como doar?", "Quero ser Voluntário", "Empresas Colaboradoras"]
  },
  {
    titulo: "Fale Conosco",
    item: [
      "(11)5555-4444",
      "contato@casadefabiano.com.br",
      "R.Dr.Luís Arrobas Martins, 255"
    ]
  }
];


const notice = [
{
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Teatro',
  title: 'teatro 1',
  desc: 'Lorem ipsum dolor sit amet, \n consectetur adipiscing elit, sed \n do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillumLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillumLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillumLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillumLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillumLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillumLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillumLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillumLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillumLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 18,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: 'https://thumbs.dreamstime.com/z/constru%C3%A7%C3%A3o-aleat%C3%B3ria-em-asheville-north-carolina-eua-65696487.jpg',
    thre: 'https://static.vecteezy.com/ti/fotos-gratis/p2/1341041-construcao-aleatoria-foto.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  },
  more: 'Saiba Mais'
},
{
  id: 1,
  casaId:1,
  casa: 'Casa de Fabiano',
  teme: 'Teatro',
  title: 'Esclarecimento',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 18,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{
  casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Teatro',
  title: 'Teatro 198',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 18,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{
  casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Teatro',
  title: 'Teatro 14645',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 18,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Teatro',
  title: 'Teatro 615',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 18,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Teatro',
  title: 'Teatro 1d',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 18,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Teatro',
  title: 'Teatro 1486',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 18,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Teatro',
  title: 'Teatro 6516',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 18,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Teatro',
  title: 'Teatro ds1',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 18,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 2,
  casa: 'Casa de Fabiano',
  teme: 'Teatro',
  title: 'Teatro 2',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 3,
  casa: 'Casa de Fabiano',
  teme: 'Evangelização',
  title: 'Evangelização 1',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Evangelização',
  title: 'Evangelização 2',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Evangelização',
  title: 'Evangelização 2',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Evangelização',
  title: 'Evangelização 2',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Evangelização',
  title: 'Evangelização 2',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Evangelização',
  title: 'Evangelização 2',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  id: 1,
  casa: 'Casa de Fabiano',
  teme: 'Evangelização',
  title: 'Evangelização 2',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  casa: 'Casa de Fabiano',
  teme: 'Evangelização',
  title: 'Evangelização 3',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  casa: 'Casa de Fabiano',
  teme: 'Mocidade',
  title: 'Mocidade 1',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:1,
  casa: 'Casa de Fabiano',
  teme: 'Mocidade',
  title: 'Mocidade 2',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Jesus.jpg',
    two: '/assets/images/Ilza%20Cintra%201.jpg',
    thre: '/assets/images/Jesus.jpg',
    four: '/assets/images/Ilza%20Cintra%201.jpg',
  }
},
{casaId:2,
  casa: 'União',
  teme: 'Teatro',
  title: 'Teatro 1 (união)',
  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut reprehenderit in voluptate velit esse cillum',
  data: '23 Jun 2021',
  like: 23,
  view: 15,
  images: {
    one: '/assets/images/Ilza%20Cintra%201.jpg',
    two: '/assets/images/Jesus.jpg',
    thre: '/assets/images/Ilza%20Cintra%201.jpg',
    four: '/assets/images/Jesus.jpg',
  }
}
]

const noticeMenu = [
  {
    casaId: 0,
    casa: "Destaque",
    topics: [
      {
        name: 'Geral',
        qtd: 20
      },
      {
        name: 'Camerata',
        qtd: 12
      },
      {
        name: 'Teatro',
        qtd: 10
      }
    ]
  },
  {
    casaId: 1,
    casa: "Casa de Fabiano",
    topics: [
      {
        name: 'Geral',
        qtd: 5
      },
      {
        name: 'Camerata',
        qtd: 8
      },
      {
        name: 'Teatro',
        qtd: 3
      },
      {
        name: 'Mocidade',
        qtd: 11
      },
      {
        name: 'Evangelização',
        qtd: 5
      },
      {
        name: 'Grupo de Estudo',
        qtd: 12
      }
    ]
  },
  {
    casaId: 2,
    casa: "União",
    topics: [
      {
        name: 'Geral',
        qtd: 5
      },
      {
        name: 'Camerata',
        qtd: 8
      },
      {
        name: 'Teatro',
        qtd: 3
      },
      {
        name: 'Mocidade',
        qtd: 11
      },
      {
        name: 'Evangelização',
        qtd: 5
      },
      {
        name: 'Grupo de Estudo',
        qtd: 12
      }
    ]
  }
]
export {data, notice, noticeMenu}